import { Injectable, inject, OnDestroy } from '@angular/core';
import { VaultStateService } from './vault-state.service';
import { fromEvent, merge, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CryptoInactivityService implements OnDestroy {
  private autoLockTimer: ReturnType<typeof setTimeout> | undefined;
  private inactivityLimitMs = 15 * 60 * 1000; // Default to 15 minutes
  private vaultState = inject(VaultStateService);

  private activitySubscription: Subscription | null = null;

  constructor() {
    this.initListeners();
  }

  private initListeners() {
    this.resetAutoLock();
    this.activitySubscription = merge(
      fromEvent(document, 'mousemove'),
      fromEvent(document, 'keydown'),
      fromEvent(document, 'click')
    ).subscribe(() => this.resetAutoLock());
  }

  updateLockoutTime(minutes: number) {
    console.log('Updating inactivity limit to:', minutes);
    this.inactivityLimitMs = minutes * 60 * 1000;
    // Reset timer with new duration if active
    if (this.vaultState.masterKey) {
      this.resetAutoLock();
    }
  }

  resetAutoLock(): void {
    if (this.autoLockTimer) clearTimeout(this.autoLockTimer);
    if (this.vaultState.masterKey) {
      this.autoLockTimer = setTimeout(() => {
        this.vaultState.lockVault();
      }, this.inactivityLimitMs);
    }
  }

  ngOnDestroy(): void {
    if (this.activitySubscription) {
      this.activitySubscription.unsubscribe();
    }
    if (this.autoLockTimer) {
      clearTimeout(this.autoLockTimer);
    }
  }
}
